import { render } from "./Dossier.vue?vue&type=template&id=42ddaccd"
import script from "./Dossier.vue?vue&type=script&lang=ts"
export * from "./Dossier.vue?vue&type=script&lang=ts"
script.render = render

export default script